export default "__VITE_ASSET__11757838__"